class InfiniteScroll extends HTMLElement {
  constructor() {
    super();
    this.currentPage = 1; // Start at page 1
    this.isLoading = false; // To prevent multiple simultaneous requests
    this.loadingOverlay = null; // Reference to the loading overlay element
  }

  connectedCallback() {
    // Extract the current page number from the URL or default to 1
    const urlParams = new URLSearchParams(window.location.search);
    this.currentPage = urlParams.get("page") || 1;

    // Get the collection URL from the attribute
    this.collectionUrl = this.getAttribute("data-collection-url");

    // Get a reference to the loading overlay
    this.loadingOverlay = this.querySelector(".loading-overlay");

    // Listen to the scroll event
    window.addEventListener("scroll", () => this.handleScroll());
  }

  // This is the standard Web Component lifecycle method
  disconnectedCallback() {
    // Any additional cleanup can be done here
    // For now, we can just log that the component has been disconnected
    console.log("Infinite Scroll component disconnected");
  }

  disconnect() {
    // Remove the event listener
    window.removeEventListener("scroll", () => this.handleScroll());
    // Hide the loadingOverlay
    this.loadingOverlay.classList.add("hidden");
    // Manually call disconnectedCallback if needed
    this.disconnectedCallback();
  }

  async handleScroll() {
    if (
      window.innerHeight + window.scrollY >=
      document.body.offsetHeight - 800
    ) {
      await this.loadMoreProducts();
    }
  }

  async loadMoreProducts() {
    if (this.isLoading) return;

    // Show the loading overlay
    this.loadingOverlay.classList.remove("hidden");

    this.isLoading = true;
    this.currentPage++;

    // Update the URL with the new page number without affecting history
    const newUrl = `${this.collectionUrl}?page=${this.currentPage}`;
    history.replaceState({}, null, newUrl);

    const response = await fetch(
      `${this.collectionUrl}?section_id=main-collection-product-grid&page=${this.currentPage}&limit=24`
    );
    const text = await response.text();
    const html = new DOMParser().parseFromString(text, "text/html");
    // Get the new items and sort them based on 'data-collection-card-position'
    let newItems = Array.from(html.querySelectorAll(".grid__item"));
    newItems.forEach((item, index) => {
      const position = item.getAttribute("data-collection-card-position");
      if (position) {
        const targetIndex = parseInt(position) - 1;
        if (targetIndex >= 0 && targetIndex < newItems.length) {
          const temp = newItems[targetIndex];
          newItems[targetIndex] = item;
          newItems[index] = temp;
        }
      }
    });

    // Check if there are no more items to load
    const resultsCount = parseInt(
      html
        .querySelector("#ProductGridContainer")
        .getAttribute("data-products-count"),
      10
    );

    if (resultsCount == 0) {
      // Stop loading more items
      this.disconnect();
      return;
    }

    // Append the newItems to the current Grid
    const productGrid = document.getElementById("product-grid");
    newItems.forEach((item) => {
      productGrid.appendChild(item);
    });

    // Hide the loading overlay
    this.loadingOverlay.classList.add("hidden");

    this.isLoading = false;
  }
}

// Register the web component
document.addEventListener("DOMContentLoaded", () => {
  customElements.define("infinite-scroll", InfiniteScroll);
});
